import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1> GRENDIZER </h1>
        <img src={logo} alt="logo" />
      </header>
    </div>
  );
}

export default App;
